













import { defineComponent, computed } from '@vue/composition-api'
import { charCount } from '@/utils/charCount'

export default defineComponent({
  name: 'AppInput',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    width: {
      type: Number,
      default: 0,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const inputWidth = computed(() => {
      if (props.width > 0) {
        return props.width
      }
      return props.value
        ? `${charCount(props.value.toString()) * 10 + 32}px`
        : '32px'
    })

    return { inputWidth }
  },
})
